import React, { useEffect, useState } from 'react';

/**
 * CommonLeisureTeklif: dijital pazarlama ve site yönetimi teklifi.
 * Route: /r/common-leisure-teklif (sidebar YOK, tam ekran belge).
 *
 * TEK A4 SAYFA. 🔴 Önce 7 slaytlık bir sunumdu, Efe "çok sloganik, tek A4'e
 * sığdır" dedi; slayt hattına geri dönme.
 * Aylık bedel deck-data.json'daki `teklif.aylik` alanında; rakam değişirse
 * orayı değiştirip `node build.js && node pdf.js`. Tasarım dili Gürgençler lansman fikirleri sunumundan geliyor,
 * CSS'i onunla ortak; o sunumlar canlıda duruyor ve bozulmamalı.
 * Yeniden üretmek için: node src/pages/common-leisure-teklif/build.js
 *
 * 🔑 "PDF indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P slaytları
 * tek sayfaya kırpar; düğmeyi dışarı taşıma.
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 *
 * HTML modülü ~8KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function CommonLeisureTeklif() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./commonLeisureTeklifHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#E9E9EC' }} />;

  return (
    <iframe
      title="Common Leisure · Teklif"
      srcDoc={html}
      style={fill}
    />
  );
}
